import { useMemo } from 'react';
import LoaderButton from '../../../../../components/UI/LoaderButton/LoaderButton';
import Coupon from '../../../../../entities/coupon';
import PricingPlanPrice from '../../../../../entities/pricing/pricingPlanPrice';

import './PayButton.scss';

export type PayButtonProps = {
	coupon: Coupon | null;
	disabled: boolean;
	onClick: () => void;
	pricingPlanPrice: PricingPlanPrice;
	sending: boolean;
	checkoutTotalCost?: number;
};

const PayButton = ( { coupon, disabled, onClick, pricingPlanPrice, sending, checkoutTotalCost }: PayButtonProps ) => {
	const payButtonContent = useMemo( () => {
		const totalCost = checkoutTotalCost ?? pricingPlanPrice.cost;
		const originalPrice = totalCost.toFixed( 2 );
		if ( !coupon ) { return `Pay $${originalPrice}`; }

		const seatsCost = totalCost - pricingPlanPrice.cost;
		const priceWithDiscount = coupon.applyDiscountTo( pricingPlanPrice ) + seatsCost;
		return (
			<div className="priceContainer">
				<span className="originalPrice" data-testid="original-price">{`$${originalPrice}`}</span>
				<span className="newPrice" data-testid="new-price">{` Pay $${priceWithDiscount.toFixed( 2 )}`}</span>
			</div>
		);
	}, [ coupon, pricingPlanPrice, checkoutTotalCost ] );

	return (
		<div className="PayButton">
			<LoaderButton
				loading={sending}
				disabled={disabled}
				size="large"
				onClick={onClick}
			>
				{payButtonContent}
			</LoaderButton>
		</div>
	);
};

export default PayButton;
